import React, { useEffect, useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import RingilTextArea from '@components/framework/input/RingilTextArea.tsx';
import { isNotBlank } from '@utils/utils.tsx';
import SvgNoteInfo from '@icons/info.svg?react';

interface ComponentProps {
  secured?: SecuredConfig;
  required?: boolean;
  readonly?: boolean;
  value: string;
  maxLength?: number;
  onChange: (value: string) => void;
}

const InternalNoteTag: React.FC<ComponentProps> = ({ secured, readonly, required, value, maxLength = 65500, onChange }) => {
  const [internalValue, setInternalValue] = useState(value);
  const { tr } = useTranslationLgs();

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  return (
    <>
      <ButtonTag secured={secured}
        label={tr('InternalNoteTag.internalnote', 'Internal note')}
        icon={<SvgNoteInfo className="text-content-gr3"/>}
        required={required}
        readonly={readonly}
        value={internalValue}
        onSave={(onSuccess) => {
          onChange(internalValue);
          onSuccess();
        }}
        autoClose
        alignTop
        popupWidth={'527px'}
        dataTestId="internalInfo-internalNote"
      >
        <RingilTextArea
          value={internalValue}
          onChange={(v) => {
            setInternalValue(isNotBlank(v) ? v : null);
          }}
          maxLength={maxLength}
          dataTestId="internalInfo-internalNoteInput"
        />
      </ButtonTag>
    </>);

};

export default InternalNoteTag;